'use strict';

import $ from 'jquery';
import { isValidFile } from '@/js/modules/file_validation';
import showTemplateFlash from '../util/show_template_flash';
import '@/js/modules/jquery_modal_defaults';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(function () {
    $(document).on('ajax:success', function (data) {
      if ($(data.target).is('.delete-link--user-file')) {
        $(data.target).closest('.user-files-list__item').remove();
      }
    });

    $(document).on('click', '.dropdown-menu__link--delete-user-file', (e) => {
      e.preventDefault();
      let { deleteUrl } = $(e.target).data();
      $('#modal--delete-confirmation--user-file').modal();
      const hiddenFromClient = window.location.search.indexOf('hidden_from_client');
      if (hiddenFromClient > 0) {
        deleteUrl = `${deleteUrl}?hidden_from_client=true`;
      }
      $('#modal--delete-confirmation--user-file .d-button--confirm-delete').attr('href', deleteUrl);

      return false;
    });

    let filesCount;
    let processedCount;
    $('.p-button--user-file-upload-button .js-file-upload').fileupload({
      url: '/user_files.json',
      add: (e, data) => {
        if (!isValidFile(data.files[0])) {
          return false;
        }
        data.submit();
      },
      change(e, data) {
        filesCount = data.files.length;
        processedCount = 0;
      },
      start: () => {
        $('.p-button--user-file-upload-button').addClass('button-loading');
      },
      done: (_, data) => {
        processedCount++;
        if (processedCount === filesCount) {
          let query = `files_count=${filesCount}`;
          const location = window.location;
          const hiddenFromClient = location.search.indexOf('hidden_from_client');
          if (hiddenFromClient > 0) {
            query = `${query}&hidden_from_client=true`;
          }
          window.location.replace(`${location.origin}${location.pathname}/uploaded?${query}`);
        }
      },
      fail: (_, data) => {
        processedCount++;
        // A 413, 502 or timeout comes back without the JSON errors.
        const errors = data.jqXHR.responseJSON?.errors ?? ['Upload failed. Please try again.'];
        if (document.body.hasAttribute('data-sidenav-layout')) {
          showTemplateFlash('user-files-alert', errors[errors.length - 1]);

          return;
        }

        const $alertFlash = $("<div class='flash flash--alert flash--user_files'></div>");
        errors.map((error) => {
          $alertFlash.html(error);
        });
        const $flash = $('main').find('.flash--user_files');
        if ($flash.length) {
          $flash.replaceWith($alertFlash);
        } else {
          $('main').prepend($alertFlash);
        }
      },
      always: () => {
        if (processedCount === filesCount) {
          $('.p-button--user-file-upload-button').removeClass('button-loading');
        }
      },
    });

    function handleFileUploads() {
      $('.user-files-link .js-file-upload').fileupload({
        url: '/user_files',
        type: 'POST',
        add: (e, data) => {
          if (!isValidFile(data.files[0])) {
            return false;
          }

          const file = data.files[0];
          const $el = $(e.target);
          const attachmentKind = $el.data().kind;
          const liClass =
            attachmentKind === 'task'
              ? 'user-files-list__item user-files-list__item--tasks'
              : 'user-files-list__item';

          let shortName = file.name;
          if (file.name.length > 39) {
            shortName = file.name.slice(0, 39) + '...';
          }

          const $li = $(`<li class="${liClass}" data-file-id="${encodeURI(data.files[0].name)}">
                      <div class="user-file">
                        <div class='user-file__icon user-file__icon--loading'></div>
                        <a href="#" class="user-file__name">${shortName}</a>
                       </div>
                      </li>`);

          const reader = new FileReader();
          reader.onload = (f) => {
            const $el = $(e.target);
            const attachmentKind = $el.data().kind;
            const recordId = $el.data().taskId || $el.data().billableId;

            data.formData = new FormData();
            data.formData.append('user_file[file]', data.files[0]);
            data.formData.append(`user_file[${attachmentKind}_id]`, recordId);
            data.formData.append('user_file[kind]', `${attachmentKind}_attachment`);
            $('.user-files-list').append($li);
            data.submit();
          };
          reader.readAsDataURL(file);
        },
        done: (_, data) => {
          $('.user-files-list')
            .find(`[data-file-id="${encodeURI(data.files[0].name)}"]`)
            .replaceWith(data.result);
        },
      });
    }

    handleFileUploads();
    $(document).on('turbo:frame-load', '#edit_task', () => {
      handleFileUploads();
    });

    $(document).on('click', '.dropdown-menu__link--copy-attachment', function (e) {
      e.preventDefault();
      const messageLink = $(this).attr('href');

      navigator.clipboard.writeText(messageLink).catch((err) => {
        console.error('Unable to copy link. Please try again.');
      });
    });
  });
});
